module.exports = __webpack_public_path__ + "static/media/holdingBeesFrontEyeLine.50a0cb3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/holdingBeesFrontEyeLine.jpg
// module id = 143
// module chunks = 0